import { UnleashFeatureFlagKeys, useUnleashFeatureFlags } from 'service/useUnleashFeatureFlags'

export const useBookingsEnabled = () => {
  const { isEnabled } = useUnleashFeatureFlags()
  return !isEnabled(UnleashFeatureFlagKeys.BOOKINGS_EXCLUDE_CUSTOMERS)
}
